const YANDEX_METRIKA_COUNTER_ID = 90215442;

declare global {
  interface Window {
    ym?: (counterId: number, method: string, target: string) => void;
  }
}

export function reachYandexMetrikaGoal(goalId: string): void {
  if (typeof window.ym === 'function') {
    window.ym(YANDEX_METRIKA_COUNTER_ID, 'reachGoal', goalId);
  }
}
